import { Transport } from "../data/api/types/schedule";
import { ReportPrinter } from "./ReportPrinter";
import { PageData } from "./usePrintJourneyListData";

export function printDrivers(
  printer: ReportPrinter,
  page: PageData,
  selectedTransport: Transport,
  width: number
) {
  let maxWidth = width;
  let tsize: {
    width: number;
    height: number;
  };

  if (!page.isExtraDriver) {
    tsize = printer.printText("Водач I смяна:", printer.pageMarginX * 2);
    maxWidth = Math.max(maxWidth, tsize.width);

    tsize = printer.printText("Водач II смяна:", printer.pageMarginX * 2);
    maxWidth = Math.max(maxWidth, tsize.width);
  } else {
    tsize = printer.printText("Водач  ......  смяна:", printer.pageMarginX * 2);
    maxWidth = Math.max(maxWidth, tsize.width);

    tsize = printer.printText("Водач  ......  смяна:", printer.pageMarginX * 2);
    maxWidth = Math.max(maxWidth, tsize.width);
  }

  if ((page.isSpecial || page.drivers.shift3) && !page.isExtraDriver) {
    tsize = printer.printText("Водач III смяна:", printer.pageMarginX * 2);
  } else if (
    selectedTransport === "TM" ||
    selectedTransport === "TB" ||
    page.drivers.shift1?.nastavnikId ||
    page.drivers.shift2?.nastavnikId ||
    page.drivers.shift3?.nastavnikId
  ) {
    tsize = printer.printText("Наставници:", printer.pageMarginX * 2);
  } else {
    tsize = printer.printText("Придружители:", printer.pageMarginX * 2);
  }
  maxWidth = Math.max(maxWidth, tsize.width);

  printer.doc.line(
    printer.pageMarginX * 2 + maxWidth + 5,
    printer.currentPageY - tsize.height * 4,
    printer.printableWidth,
    printer.currentPageY - tsize.height * 4
  );
  printer.doc.line(
    printer.pageMarginX * 2 + maxWidth + 5,
    printer.currentPageY - tsize.height * 3,
    printer.printableWidth,
    printer.currentPageY - tsize.height * 3
  );
  printer.doc.line(
    printer.pageMarginX * 2 + maxWidth + 5,
    printer.currentPageY - tsize.height * 2,
    printer.printableWidth,
    printer.currentPageY - tsize.height * 2
  );
  printer.doc.line(
    printer.pageMarginX * 2 + maxWidth + 5,
    printer.currentPageY - tsize.height,
    printer.printableWidth,
    printer.currentPageY - tsize.height
  );

  printer.withFont(
    () => {
      if (page.drivers.shift1) {
        printer.doc.text(
          page.drivers.shift1.name,
          printer.pageMarginX * 2 + maxWidth + 10,
          printer.currentPageY - 3 * tsize.height - 2
        );
      }

      if (page.drivers.shift2) {
        printer.doc.text(
          page.drivers.shift2.name,
          printer.pageMarginX * 2 + maxWidth + 10,
          printer.currentPageY - 2 * tsize.height - 2
        );
      }

      if (
        !((page.isSpecial || page.drivers.shift3) && !page.isExtraDriver) &&
        (page.drivers.shift1?.nastavnikId ||
          page.drivers.shift2?.nastavnikId ||
          page.drivers.shift3?.nastavnikId)
      ) {
        const nastavnikTexts: string[] = [];

        if (page.drivers.shift1?.nastavnikId) {
          if (page.drivers.shift1.nastavnikName) {
            nastavnikTexts.push(
              `I-ва см.: ${page.drivers.shift1.nastavnikName} (${page.drivers.shift1.nastavnikId})`
            );
          } else {
            nastavnikTexts.push(`I-ва см.: ${page.drivers.shift1.nastavnikId}`);
          }
        }
        if (page.drivers.shift2?.nastavnikId) {
          if (page.drivers.shift2.nastavnikName) {
            nastavnikTexts.push(
              `II-ра см.: ${page.drivers.shift2.nastavnikName} (${page.drivers.shift2.nastavnikId})`
            );
          } else {
            nastavnikTexts.push(
              `II-ра см.: ${page.drivers.shift2.nastavnikId}`
            );
          }
        }
        // if (page.drivers.shift3?.nastavnikId) {
        //   if (page.drivers.shift3.nastavnikName) {
        //     nastavnikTexts.push(
        //       `III-та см.: ${page.drivers.shift3.nastavnikName} (${page.drivers.shift3.nastavnikId})`
        //     );
        //   } else {
        //     nastavnikTexts.push(
        //       `III-та см.: ${page.drivers.shift3.nastavnikId}`
        //     );
        //   }
        // }

        printer.doc.text(
          nastavnikTexts.join(";   "),
          printer.pageMarginX * 2 + maxWidth + 10,
          printer.currentPageY - 1 * tsize.height - 2
        );
      } else if (page.drivers.shift3) {
        printer.doc.text(
          page.drivers.shift3.name,
          printer.pageMarginX * 2 + maxWidth + 10,
          printer.currentPageY - 1 * tsize.height - 2
        );
      }
    },
    "slab-normal",
    12,
    1
  );

  printer.withFont(
    () => {
      if (page.drivers.shift1) {
        printer.doc.text(
          page.drivers.shift1.sl_number,
          printer.pageMarginX * 2 + 500,
          printer.currentPageY - 3 * tsize.height - 2
        );

        printer.doc.text(
          page.drivers.shift1.lines,
          printer.printableWidth,
          printer.currentPageY - 3 * tsize.height - 2,
          { align: "right" }
        );
      }

      if (page.drivers.shift2) {
        printer.doc.text(
          page.drivers.shift2.sl_number,
          printer.pageMarginX * 2 + 500,
          printer.currentPageY - 2 * tsize.height - 2
        );

        printer.doc.text(
          page.drivers.shift2.lines,
          printer.printableWidth,
          printer.currentPageY - 2 * tsize.height - 2,
          { align: "right" }
        );
      }

      if (page.drivers.shift3) {
        printer.doc.text(
          page.drivers.shift3.sl_number,
          printer.pageMarginX * 2 + 500,
          printer.currentPageY - 1 * tsize.height - 2
        );

        printer.doc.text(
          page.drivers.shift3.lines,
          printer.printableWidth,
          printer.currentPageY - 1 * tsize.height - 2,
          { align: "right" }
        );
      }
    },
    "slab-bold",
    16,
    1
  );
}
